export default __webpack_public_path__ + "static/icecream-987263c141700bd998bd5cad73e0768c.png";